<template>
    <div class="content">
        <div>
            <!--            <h1>asf</h1>-->
            <div id="realtime-porject-area"></div>
        </div>
        <div id="realtime-bar">
            <!--            <ul>-->
            <!--                <li v-for="dat in datas" :key="dat.id">{{dat}}</li>-->
            <!--            </ul>-->
        </div>
    </div>
</template>

<script>
    import {CreditPorjectRealtimeArea} from "../../../../network/projectAnalysis";

    const geoCoordMap = {
        '上海': [119.1803, 31.2891],
        "福建": [119.4543, 25.9222],
        "重庆": [108.384366, 30.439702],
        '北京': [116.4551, 40.2539],
        "辽宁": [123.1238, 42.1216],
        "河北": [114.4995, 38.1006],
        "天津": [117.4219, 39.4189],
        "山西": [112.3352, 37.9413],
        "陕西": [109.1162, 34.2004],
        "甘肃": [103.5901, 36.3043],
        "宁夏": [106.3586, 38.1775],
        "青海": [101.4038, 36.8207],
        "新疆": [87.9236, 43.5883],
        "西藏": [91.11, 29.97],
        "四川": [103.9526, 30.7617],
        "吉林": [125.8154, 44.2584],
        "山东": [117.1582, 36.8701],
        "河南": [113.4668, 34.6234],
        "江苏": [118.8062, 31.9208],
        "安徽": [117.29, 32.0581],
        "湖北": [114.3896, 30.6628],
        "浙江": [119.5313, 29.8773],
        '内蒙古': [110.3467, 41.4899],
        "江西": [116.0046, 28.6633],
        "湖南": [113.0823, 28.2568],
        "贵州": [106.6992, 26.7682],
        "云南": [102.9199, 25.4663],
        "广东": [113.12244, 23.009505],
        "广西": [108.479, 23.1152],
        "海南": [110.3893, 19.8516],
        '黑龙江': [127.9688, 45.368],
        '台湾': [121.4648, 25.5630]
    };
    var index = 0;
    export default {
        name: "DayAreaBarv2",
        data() {
            return {
                series: {},
                option: {
                    title: {
                        text: '实时项目检测',
                        // left: 200,
                        textStyle: {
                            color: "#f7f7b6",
                            fontSize: 16,
                        },
                        // right: 140,
                        // top: 100,
                        left: "middle",
                        textAlign: 'center',
                        z: 0,
                        // right: "auto",
                    },
                    legend: {
                        right: 200,
                        data: ['报告表', '报告书'],
                        // selected: {
                        //     '报告书': true,
                        //     '报告表': true,
                        // }

                    },
                    tooltip: {
                        // trigger: 'axis',
                        position: 'right',
                        axisPointer: {
                            type: 'shadow'
                        }
                    },
                    toolbox: {
                        feature: {
                            saveAsImage: {
                                pixelRatio: 2,
                                backgroundColor: "#1D2A48"
                            },

                        },
                        right: 70,
                        iconStyle: {
                            borderColor: '#f7f7b6'
                        },
                    },
                    geo: {
                        map: 'china',
                        label: {
                            position: "insideTopRight",
                            show: true,
                            color: '#f7f7b6',
                            fontSize: 16,
                            textBorderColor: "443B60",
                            emphasis: {
                                color: '#f7f7b6',
                                show: false
                            }
                        },
                        roam: false,//是否允许缩放
                        top: 80,
                        left: 90,
                        zoom: 1, //默认显示级别
                        scaleLimit: {
                            min: 0,
                            max: 3
                        }, //缩放级别

                        itemStyle: {
                            normal: {
                                borderColor: '#1B2947',
                                borderWidth: 1,
                                color: "#ffffff",
                                shadowColor: 'rgba(255, 255, 255, 0)',
                                shadowOffsetX: -2,
                                shadowOffsetY: 2,
                                shadowBlur: 10
                            },
                            emphasis: {
                                label: {
                                    color: '#79ADDB'
                                },
                                color: "#7e5077",
                                borderWidth: 0,
                            }
                        },

                        tooltip: {
                            show: true
                        }
                    },
                    series: [

                        {
                            type: 'effectScatter',
                            coordinateSystem: 'geo',
                            z: 1,
                            data: [],
                            symbolSize: 14,
                            label: {
                                normal: {
                                    fontSize: 28,
                                    show: true,
                                    formatter: function (params) {
                                        return '{tline|项目名称：' + params.data.project_name + '\n' + '}' +
                                            '{tline|建设地点：' + params.data.site + '\n' + '}' +
                                            '{tline|编制单位：' + params.data.build_unit_name + '\n' + '}' +
                                            '{tline|建设单位：' + params.data.compile_unit_name + '\n' + '}' +
                                            '{tline|行业类别：' + params.data.industry_type + '\n' + '}' +
                                            '{tline|环评类别：' + params.data.eia_type + '}';
                                    },
                                    position: 'top',
                                    // backgroundColor: '#A6642B',
                                    backgroundColor: 'rgba(254,174,33,.9)',
                                    opacity: 0.5,
                                    padding: [10, 10, 10, 10],
                                    borderRadius: 5,
                                    lineHeight: 20,
                                    color: '#2f4554',
                                    rich: {
                                        tline: {
                                            color: '#ffffff'
                                        }
                                    }
                                },
                                emphasis: {
                                    show: true
                                }
                            },
                            itemStyle: {
                                color: '#feae21',
                            }
                        },
                        {
                            type: 'effectScatter',
                            coordinateSystem: 'geo',
                            z: 1,
                            data: [],
                            symbolSize: 14,
                            label: {
                                normal: {
                                    show: true,
                                    formatter: function (params) {
                                        return '{tline|项目名称：' + params.data.project_name + '\n' + '}' +
                                            '{tline|建设地点：' + params.data.site + '\n' + '}' +
                                            '{tline|编制单位：' + params.data.build_unit_name + '\n' + '}' +
                                            '{tline|建设单位：' + params.data.compile_unit_name + '\n' + '}' +
                                            '{tline|行业类别：' + params.data.industry_type + '\n' + '}' +
                                            '{tline|环评类别：' + params.data.eia_type + '}';
                                    },
                                    position: 'top',
                                    // backgroundColor: '#2585A0',
                                    backgroundColor: "rgba(233,63,66,.9)",
                                    padding: [10, 10, 10, 10],
                                    borderRadius: 5,
                                    lineHeight: 20,
                                    color: '#ffffff',
                                    rich: {
                                        tline: {
                                            color: '#ffffff'
                                        }
                                    },
                                    emphasis: {
                                        show: true
                                    }
                                }
                            },
                            itemStyle: {
                                color: '#e93f42',

                            }

                        },
                        {
                            type: 'effectScatter',
                            coordinateSystem: 'geo',
                            z: 1,
                            data: [],
                            symbolSize: 14,
                            label: {
                                normal: {
                                    show: true,
                                    formatter: function (params) {
                                        return '{tline|项目名称：' + params.data.project_name + '\n' + '}' +
                                            '{tline|建设地点：' + params.data.site + '\n' + '}' +
                                            '{tline|编制单位：' + params.data.build_unit_name + '\n' + '}' +
                                            '{tline|建设单位：' + params.data.compile_unit_name + '\n' + '}' +
                                            '{tline|行业类别：' + params.data.industry_type + '\n' + '}' +
                                            '{tline|环评类别：' + params.data.eia_type + '}';
                                    },
                                    position: 'top',
                                    padding: [10, 10, 10, 10],
                                    borderRadius: 5,
                                    lineHeight: 20,
                                    // backgroundColor: '#E93F43',
                                    backgroundColor: 'rgba(8,186,236,.9)',
                                    color: '#ffffff',
                                    rich: {
                                        tline: {
                                            color: '#ffffff'
                                        },

                                    }
                                },
                                emphasis: {
                                    show: true
                                }
                            },
                            itemStyle: {
                                color: '#08baec',
                            }
                        },
                        {
                            name: "报告总数",
                            type: 'map',
                            map: 'china',
                            geoIndex: 0,
                            z: 0,
                            // left: 100,
                            // top: 0,
                            label: {
                                show: false,
                                color: "red",
                                fontSize: 18
                            },
                            zoom: 0.9,

                            data: [],
                        },
                    ],
                    visualMap: [{
                        type: "piecewise",
                        show: true,
                        seriesIndex: 3,
                        bottom: 50,
                        left: 150,
                        inRange: {
                            symbol: 'rect',
                            color: ['#ffffff', '#59446c']
                        },
                        textStyle: {
                            color: "#f7f7b6",
                        },

                        pieces: [
                            {min: 100},
                            // {min:1000, max:9999},
                            {min: 70, max: 99},
                            {min: 40, max: 69},
                            {min: 20, max: 39},
                            {min: 10, max: 19},
                            {min: 1, max: 9},
                            {min: 0, max: 0},
                        ]
                    }],
                    animationEasing: 'elasticOut',
                    // animationDelayUpdate: 1000,
                },
                optionbar: {
                    title: {
                        text: '24小时各省项目排行',
                        // left: 200,
                        textStyle: {
                            color: "#f7f7b6",
                            fontSize: 16,
                        },
                        // right: 140,
                        // top: 100,
                        // left: 500,
                        // z: 0,
                        // right: "auto",
                    },
                    color: ["#674b75", "#edebef"],
                    grid: {
                        // right: 10,
                        bottom: 20,
                        left: -50,
                        // top: 50,
                        containLabel: true,
                        // height: 650,
                        // width: 300,
                    },
                    legend: {
                        right: 100,
                        data: ['报告表', '报告书'],
                        // selected: {
                        //     '报告书': true,
                        //     '报告表': true,
                        // }
                        textStyle: {
                            color: "#f7f7b6",
                            fontSize: 14,
                        },
                    },
                    tooltip: {
                        // trigger: 'axis',
                        axisPointer: {
                            type: 'shadow'
                        }
                    },
                    toolbox: {
                        feature: {
                            magicType: {
                                type: ['stack', 'tiled']
                            },
                            saveAsImage: {
                                pixelRatio: 2,
                                backgroundColor: "#1D2A48",

                            },

                        },
                        iconStyle: {
                            borderColor: '#f7f7b6'
                        },
                        top: -5,
                        right: 0,
                    },
                    xAxis: {
                        // data: y_axis,
                        type: 'value',
                        // splitLine: false,
                        splitLine: {
                            show: false
                        },
                        axisLabel: {
                            interval: 0,
                            // margin: 80,
                            textStyle: {
                                color: '#f7f7b6',
                                align: 'left',
                                fontSize: 16,

                            },
                        }

                    },
                    yAxis: {
                        type: 'category',
                        inverse: true,
                        // nameGap: 16,
                        // splitLine: false,
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: "black",
                            }
                        },
                        axisTick: {
                            show: true,
                            lineStyle: {
                                color: '#ddd'
                            }
                        },
                        axisLabel: {
                            // interval: 0,
                            margin: 80,
                            textStyle: {
                                color: '#f7f7b6',
                                align: 'left',
                                fontSize: 16,

                            },
                            rich: {
                                a: {
                                    color: '#ffffff',
                                    backgroundColor: '#f0515e',
                                    width: 20,
                                    height: 20,
                                    align: 'center',
                                    // borderRadius: 2,
                                },
                                b: {
                                    color: '#ffffff',
                                    backgroundColor: '#24a5cd',
                                    width: 20,
                                    height: 20,
                                    align: 'center',
                                    // borderRadius: 2,
                                }
                            },
                            formatter: function (params) {
                                if (parseInt(params.slice(0, 2)) < 5) {
                                    return [
                                        '{a|' + (parseInt(params.slice(0, 2)) + 1) + '}' + '  ' + params.slice(2)
                                    ].join('\n')
                                } else {
                                    return [
                                        '{b|' + (parseInt(params.slice(0, 2)) + 1) + '}' + '  ' + params.slice(2)
                                    ].join('\n')
                                }
                            }
                        },

                        // },
                        // data: x_axis,
                    },
                    dataZoom: [
                        {
                            // type: 'inside',
                            showDetail: false,
                            start: 0,
                            end: 50,
                            yAxisIndex: 0,
                            // width: 20,
                        },
                    ],
                    series: [
                        {
                            name: '报告表',
                            type: 'bar',
                            // left: 600,
                            roam: false,
                            visualMap: false,
                            // data: y_axis,
                            stack: '总量',
                            label: {
                                normal: {
                                    show: true,
                                    fontSize: 14,
                                    color: "#f7f7b6",
                                    textBorderColor: '#333',
                                    textBorderWidth: 2
                                }
                            },
                            animationDelay: function (idx) {
                                return idx * 10

                            }
                        },
                        {
                            name: '报告书',
                            type: 'bar',
                            show: false,
                            // data: y_axis,
                            // left: 600,
                            stack: '总量',
                            label: {
                                normal: {
                                    show: true,
                                    fontSize: 14,
                                    color: "#f7f7b6",
                                    textBorderColor: '#333',
                                    textBorderWidth: 2
                                }
                            },
                            animationDelay: function (idx) {
                                return idx * 10 + 100

                            }
                        },
                        {

                            type: 'pie',
                            data: [
                                {name: "报告表", value: 0},
                                {name: "报告书", value: 0}
                            ],
                            z: 3,
                            center: ['65%', '80%'],
                            radius: '40%',
                            selectedOffset: 20,
                            label: {
                                formatter: '{c|数量：{c}}\n{per|百分比:{d}%} ',
                                position: "inside",
                                lineHeight: 20,
                                rich: {
                                    c: {
                                        color: '#f7f7b6',
                                        align: 'center',
                                        fontSize: 14,
                                        textBorderColor: '#333',
                                    },
                                    per: {
                                        color: '#f7f7b6',
                                        align: 'center',
                                        fontSize: 14,
                                        textBorderColor: '#333',
                                    }
                                }
                            },

                        },


                    ],
                    animationEasing: 'elasticOut',
                    // animationDelayUpdate: 1000,
                }
            }
        }
        ,
        mounted() {
            var waterMarkText = '✪广州绿网✪';
            var canvas = document.createElement('canvas');
            var ctx = canvas.getContext('2d');
            canvas.width = canvas.height = 500;
            ctx.fillStyle = "#1f2b4a";
            ctx.fillRect(0, 0, 1000, 1000);
            ctx.textAlign = 'center';
            ctx.fillStyle = "orange";
            ctx.textBaseline = 'middle';
            ctx.font = '30px LiSu';
            ctx.translate(50, 150);
            ctx.rotate(-Math.PI / 6);
            ctx.fillText(waterMarkText, 200, 200);

            this.option.toolbox.feature.saveAsImage.backgroundColor = {
                // type: "patten",
                image: canvas,
                // repeat: 'repeat',

            };

            this.optionbar.toolbox.feature.saveAsImage.backgroundColor = {
                // type: "patten",
                image: canvas,
                // repeat: 'repeat',

            };


            var echarts = require('echarts');
            var myChart = echarts.init(document.getElementById('realtime-porject-area'));
            var myChartbar = echarts.init(document.getElementById('realtime-bar'));
            myChart.showLoading();
            myChartbar.showLoading();
            CreditPorjectRealtimeArea().then(response => {

                    var x_axis = [];
                    var y_axis_biao = [];
                    var y_axis_shu = [];
                    var compare = (prop) => {
                        return (a, b) => {
                            return a[prop] < b[prop] ? 1 : -1
                        }
                    }
                    response.data['result']['全部'].sort(compare('value'));
                    for (var i = 0; i < response.data['result']['全部'].length; i++) {
                        var names = response.data['result']['全部'][i]['name']
                        if (i < 10) {
                            x_axis.push('0' + i + names);
                        } else {
                            x_axis.push(i + names);
                        }


                        // console.log(response.data['result'])
                        y_axis_biao.push({'name': names, 'value': response.data['result']['报告表'][names]});
                        y_axis_shu.push({'name': names, 'value': response.data['result']['报告书'][names]})
                    }

                    this.series = response.data['result']
                    // this.series['x_axis'] = x_axis
                    // this.series['y_axis'] = y_axis
                    this.optionbar.yAxis.data = x_axis
                    this.optionbar.series[0].data = y_axis_biao
                    this.optionbar.series[1].data = y_axis_shu
                    this.optionbar.series[2].data[0]['value'] = response.data['result']['总数']['报告表']
                    this.optionbar.series[2].data[1]['value'] = response.data['result']['总数']['报告书']
                    this.option.series[3].data = response.data['result']['全部']
                    myChartbar.hideLoading();
                    myChart.hideLoading();
                    myChartbar.setOption(this.optionbar, true);
                    myChart.setOption(this.option, true);
                    if (response.data['result']['总数']['报告表'] === 0 &
                        response.data['result']['总数']['报告书'] === 0
                    ) {
                        this.open1()
                    } else {
                        setInterval(() => {
                            var typeidx = index % 3;
                            var item = this.series['详情'][99 - index]
                            if (typeidx === 0) {
                                this.option.series[typeidx].z = 2
                                this.option.series[1].z = 1
                                this.option.series[2].z = 1
                            } else if (typeidx === 1) {
                                this.option.series[typeidx].z = 2
                                this.option.series[0].z = 1
                                this.option.series[2].z = 1
                            } else {
                                this.option.series[typeidx].z = 2
                                this.option.series[0].z = 1
                                this.option.series[1].z = 1
                            }
                            this.option.series[typeidx].data = [{
                                project_name: item['project_name'],
                                site: item['site'],
                                eia_type: item['eia_type'],
                                compile_unit_name: item['compile_unit_name'],
                                build_unit_name: item['build_unit_name'],
                                industry_type: item['industry_type'],
                                value: geoCoordMap[item['geo']]
                            }];
                            index += 1
                            if (index === 100) {
                                index = 0
                            }
                            myChart.setOption(this.option, true);
                        }, 3000);
                    }

                }
            ).catch(function (error) {
                console.log(error)
            });

        }
        ,
        created() {

        },
        methods: {
            open1() {
                this.$message({
                    showClose: true,
                    message: '数据来源网站正在维护中，实时暂无数据。' +
                        '维护时间为：2020年7月26日至2020年7月28日',
                    duration: 0,
                    offset: 100,
                });
            }
            ,
        }
    }
</script>

<style scoped>
    .content {

        height: 100vh;
        width: 1640px;
        /*background-color: #71a4d1;*/
        /*display: block;*/
    }

    #realtime-porject-area {
        margin-top: 100px;
        width: 70%;
        height: 90vh;
        float: left;
        /*margin-left: 400px;*/
        /*margin-top: 30px;*/
        /*padding-top: 60px;*/
        /*background-color: #f7f7f7;*/
    }

    #realtime-bar {
        margin-top: 100px;
        width: 30%;
        height: 90vh;
        float: right;
        /*margin-right: 30px;*/
        /*margin-top: 30px;*/
        /*padding-top: 60px;*/
        /*background-color: #f7f7f7;*/
    }
</style>